import React, { useEffect } from "react";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useAuth } from "./clerkReact";
import { useNavigate } from "react-router-dom";

const ClerkLogoutPage = () => {
  const { signOut, isLoaded } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoaded) return;
    signOut().then(() => navigate("/"));
  }, [isLoaded, navigate, signOut]);

  return (
    <Center h="100vh" flexDirection="column" gap={3}>
      <Spinner size="lg" />
      <Text>Signing out...</Text>
    </Center>
  );
};

export default ClerkLogoutPage;
